import React from 'react';
import { RoughNotation } from "react-rough-notation";

const LocationDisplay = () => {
  const states = {
    "South Australia": {
      color: "#346eb8",
      class:"text-white",
      image: "/Icons/LGA-SDA-SouthAustralia-REVISED.svg",
      cities: [
        ["Encounter Bay", "Northfield"],
        ["Christies", "Paralowie"],
        ["Morphette Vale", "Parahills"],
        ["Seaford", "Mansfield Park"],
        ["Marion", "Ingle Farm"],
        ["Brighton", "Blair Athol"],
        ["Clearview", "Elizabeth"],
        ["Mt. Barker", "Prospect"]
      ]
    },
    "Queensland": {
      color: "#ffcc00",
      class:"text-[#222]",
      image: "/Icons/LGA-SDA-Queensland-REVISED.svg",
      cities: [
        ["Marsden", ""],
        ["Morayfield", ""],
        ["Kingaroy", ""],
        ["Caboolture", ""]
      ]
    },
    "Victoria": {
      color: "#54b61a",
      class:"text-white",
      image: "/Icons/LGA-SDA-Victoria-REVISED.svg",
      cities: [
        ["Victoria", ""]
      ]
    }
  };

  return (
    <div className="p-4 md:p-8 max-w-6xl py-12 md:py-24 mx-auto">
      <div className="relative mb-12 md:mb-24">
        <div className="text-center">
          <RoughNotation
            type="highlight"
            show={true}
            color="#E6D5E8"
            strokeWidth={2}
            padding={8}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-primary font-arial-rounded inline-block">OUR LOCATIONS</h1>
          </RoughNotation>
        </div>
      </div>
     
      <div className="space-y-12 md:space-y-16">
        {Object.entries(states).map(([state, data]) => (
          <div key={state} className="relative">
            <div className="flex flex-col md:flex-row md:justify-between md:items-start">
              <div className="flex-grow mb-8 md:mb-0">
                <h2 className="text-lg md:text-3xl font-semibold mb-4 md:mb-6">{state}</h2>
                <div className={"grid grid-cols-1 md:grid-cols-2 gap-x-8 md:gap-x-16 gap-y-2 md:gap-y-4" + " " + data.class}>
                  {data.cities.map(([left, right], idx) => (
                    <RoughNotation
                      key={idx}
                      type="highlight"
                      show={true}
                      color={data.color}
                      strokeWidth={2}
                      padding={2}
                      iterations={1}
                    >
                      <div className="flex justify-between px-4 gap-4 md:gap-8">
                        <span className="text-sm md:text-xl">{left}</span>
                        <span className="text-sm md:text-xl">{right}</span>
                      </div>
                    </RoughNotation>
                  ))}
                </div>
              </div>
              <div className="mx-auto md:ml-8 md:flex-shrink-0 md:translate-x-8 relative">

                {/* Main image circle */}
                <div className="w-48 h-48 md:w-48 md:h-48 overflow-hidden relative z-10">
                  <img
                    src={data.image}
                    alt={state}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationDisplay;